import styled from 'styled-components'

export const TopNav = styled.div`
    background: var(--bg-color);
    position: sticky;
    top: 0;
    z-index: 10;
`
